import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgToastService } from 'ng-angular-popup';
import { RfiService } from '@/app/services/rfi/rfi.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    RichTextEditorComponent,
  ],
  selector: 'app-fill-rfi',
  templateUrl: './fill-rfi.component.html',
  styleUrls: ['./fill-rfi.component.css'],
})
export class FillRfiComponent implements OnInit, OnChanges {
  @ViewChild('addRfiDialog') addRfiDialog!: TemplateRef<any>;
  @Input() isDialogOpen: boolean;
  @Input() isClient: boolean;
  @Input() rfiResponseId: number;
  @Output() loadRfiInfo: EventEmitter<any> = new EventEmitter<any>();
  rfiId: number;
  projectName: string;
  projectIdentifier: string;
  editRFIId: number;
  projectId: number;
  rfiForm = new FormGroup({
    clarification: new FormControl('', Validators.required),
    attachments: new FormControl([]),
  });
  isDragging = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private toast: NgToastService,
    private rfiService: RfiService,
    private router: Router,
    private route: ActivatedRoute,
    private getProjectIdService: GetProjectIdService,
    private activatedRoute: ActivatedRoute,
    private getFileIconService: GetFileIconUtilityService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });
    this.rfiId = +this.activatedRoute.snapshot.paramMap.get('rfiId')!;
    this.projectId = +this.getProjectIdService.getProjectId();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isDialogOpen'] && !changes['isDialogOpen'].firstChange) {
      this.rfiForm.reset();
      this.openAddRfiDialog();
    }
  }
  openAddRfiDialog() {
    this.dialog.open(this.addRfiDialog, {
      disableClose: true,
      autoFocus: false,
    });
  }
  closeDialog() {
    this.dialog.closeAll();
  }
  // Handle RFI form submission
  async submitRFI() {
    const dataToSubmit: any = await this.prepareRFIDataToSubmit();
    if (!dataToSubmit) return;

    if (this.isClient) {
      this.rfiService.submitRfiResponse(dataToSubmit, this.rfiId).subscribe({
        next: (response: any) => {
          if (response.meta.success) {
            this.toast.success(
              'RFI response submitted successfully',
              'SUCCESS',
              4000
            );
            this.rfiForm.reset();
            this.closeDialog();
            this.loadRfiInfo.emit();
          }
        },
        error: (error: any) => {
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.rfiService
        .updateRfiResponse(dataToSubmit, this.rfiResponseId)
        .subscribe({
          next: (response: any) => {
            if (response.meta.success) {
              this.toast.success(
                'RFI response submitted successfully',
                'SUCCESS',
                4000
              );
              this.rfiForm.reset();
              this.closeDialog();
              this.loadRfiInfo.emit();
            }
          },
          error: (error: any) => {
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    }
  }
  async prepareRFIDataToSubmit() {
    if (this.rfiForm.invalid) {
      this.rfiForm.markAllAsTouched();
      return;
    }

    const formData = new FormData();
    if (this.isClient) {
      formData.append('response', this.rfiForm.value.clarification);
      const files: any = this.rfiForm.value.attachments;
      for (let i = 0; i < files.length; i++) {
        formData.append('rfi_response_attach[]', files[i]);
      }
    } else {
      formData.append('third_party_response', this.rfiForm.value.clarification);
      const files: any = this.rfiForm.value.attachments;
      for (let i = 0; i < files.length; i++) {
        formData.append('rfi_response_attach_third_party[]', files[i]);
      }
    }

    return formData;
  }

  onFileChange(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.rfiForm.patchValue({ attachments: files });
      this.rfiForm.get('attachments')?.markAsTouched();
    }
  }
  addClarification(content: string) {
    this.rfiForm.controls['clarification'].setValue(content);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    console.log('The location file is:', event.dataTransfer.files);
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer?.files) {
      this.onFileUpload(event, true);
    }
  }

  // Handle file upload
  onFileUpload(event: any, isDrop = false) {
    let files: any;
    if (isDrop) {
      console.log('The drop file is:', event.dataTransfer.files);
      files = event.dataTransfer.files;
    } else {
      files = event.target.files;
    }
    const fileArray = Array.from(files);

    const existingFiles = this.rfiForm.get('attachments')?.value || [];

    const updatedFiles = [...existingFiles, ...fileArray];

    this.rfiForm.get('attachments')?.setValue(updatedFiles);

    this.rfiForm.get('attachments')?.markAsDirty();
  }
  removeAttachment(index: number) {
    const files = this.rfiForm.get('attachments')?.value || [];
    files.splice(index, 1);
    this.rfiForm.get('attachments')?.setValue([...files]);
  }

  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
  handleCancel() {
    this.closeDialog();
  }
}
